<template>
  <section class="testimonials-section">
    <h2 class="testimonial-subtitle">What Our Customers Say</h2>
    <h1 class="testimonial-title">User Testimonials</h1>
    <div class="underline"></div>

    <div class="carousel-container">
      <!-- Left Arrow -->
      <button class="nav-btn prev" @click="prevSlide">
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- Testimonial Cards -->
      <div class="carousel-wrapper">
        <div
          v-for="(testimonial, index) in visibleTestimonials"
          :key="index"
          class="testimonial-card"
        >
          <div class="quote-icon">“</div>
          <h3 class="testimonial-heading">“{{ testimonial.title }}”</h3>
          <p class="testimonial-text">
            {{ testimonial.text }}
          </p>

          <div class="testimonial-footer">
            <img
              v-if="testimonial.logo"
              :src="testimonial.logo"
              alt="lab logo"
              class="lab-logo"
            />
            <div v-else class="lab-logo-placeholder">
              <i class="fas fa-user"></i> <!-- You can change icon -->
            </div>
            
            <div class="lab-info">
              <h4 class="lab-name">{{ testimonial.lab }}</h4>
              <p class="lab-location">{{ testimonial.location }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Arrow -->
      <button class="nav-btn next" @click="nextSlide">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <!-- Pagination -->
    <div class="pagination-dots">
      <span
        v-for="(dot, i) in totalPages"
        :key="i"
        :class="{ active: currentPage === i }"
        @click="goToPage(i)"
      ></span>
    </div>
  </section>
</template>

<script>
// ✅ Import your logo images here
import plasmaLogo from "@/assets/images/pages/plasma_diagnostics.webp";
import medLogo from "@/assets/images/pages/medclinical_laboratory.webp";

export default {
  name: "UserTestimonials",
  data() {
    return {
      currentPage: 0,
      perPage: 3,
      testimonials: [
        {
          title: "Best Support and User Friendly",
          text: "MedLab’s interface is clean, intuitive, and easy to navigate, making our daily operations much smoother. Their support team truly stands out, quick to respond, knowledgeable, and always ready to resolve issues with a professional and friendly approach.",
          lab: "Plasma Diagnostics",
          location: "Bankura, West Bengal",
          logo: plasmaLogo, // ✅ Works now
        },
        {
          title: "Seamless Workflow and Efficiency",
          text: "Since adopting MedLab, our entire lab workflow has become more efficient and organized. From test registration to final reporting, every process feels streamlined, saving valuable time while reducing manual errors.",
          lab: "Med Clinical Laboratory",
          location: "Manjeshwar, Kasargod",
          logo: medLogo,
        },
        {
          title: "Trusted Partner with Great Support",
          text: "We’ve been using MedLab for over 9 years, and it continues to exceed expectations. The software is user-friendly, affordable, and regularly updated, making it a reliable long-term partner for our lab.",
          lab: "Indian Health Center",
          location: "Farangipete, Mangalore",
          logo: "", // No logo
        },
        {
          title: "Smooth Integration and Great UX",
          text: "Integration with existing systems was seamless. The interface is modern, quick, and efficient, making team onboarding effortless.",
          lab: "City Diagnostic Center",
          location: "Kochi, Kerala",
          logo: "", // No logo
        },
        {
          title: "Best Support and User Friendly",
          text: "MedLab’s interface is clean, intuitive, and easy to navigate, making our daily operations much smoother. Their support team truly stands out, quick to respond, knowledgeable, and always ready to resolve issues with a professional and friendly approach.",
          lab: "Plasma Diagnostics",
          location: "Bankura, West Bengal",
          logo: plasmaLogo,
        },
        {
          title: "Seamless Workflow and Efficiency",
          text: "Since adopting MedLab, our entire lab workflow has become more efficient and organized. From test registration to final reporting, every process feels streamlined, saving valuable time while reducing manual errors.",
          lab: "Med Clinical Laboratory",
          location: "Manjeshwar, Kasargod",
          logo: medLogo,
        },
        {
          title: "Trusted Partner with Great Support",
          text: "We’ve been using MedLab for over 9 years, and it continues to exceed expectations. The software is user-friendly, affordable, and regularly updated, making it a reliable long-term partner for our lab.",
          lab: "Indian Health Center",
          location: "Farangipete, Mangalore",
          logo: "",
        },
        {
          title: "Smooth Integration and Great UX",
          text: "Integration with existing systems was seamless. The interface is modern, quick, and efficient, making team onboarding effortless.",
          lab: "City Diagnostic Center",
          location: "Kochi, Kerala",
          logo: "",
        },
        {
          title: "Best Support and User Friendly",
          text: "MedLab’s interface is clean, intuitive, and easy to navigate, making our daily operations much smoother. Their support team truly stands out, quick to respond, knowledgeable, and always ready to resolve issues with a professional and friendly approach.",
          lab: "Plasma Diagnostics",
          location: "Bankura, West Bengal",
          logo: plasmaLogo,
        },
      ],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.testimonials.length / this.perPage);
    },
    visibleTestimonials() {
      const start = this.currentPage * this.perPage;
      return this.testimonials.slice(start, start + this.perPage);
    },
  },
  methods: {
    nextSlide() {
      this.currentPage = (this.currentPage + 1) % this.totalPages;
    },
    prevSlide() {
      this.currentPage =
        (this.currentPage - 1 + this.totalPages) % this.totalPages;
    },
    goToPage(index) {
      this.currentPage = index;
    },
  },
};
</script>


<style scoped>
.testimonials-section {
  padding: 80px 20px;
  text-align: center;
  background: #fff;
}

.testimonial-subtitle {
  font-size: 1.2rem;
  color: #444;
}

.testimonial-title {
  font-size: 2rem;
  color: #206a98;
  font-weight: bold;
  margin-top: 5px;
}

.underline {
  width: 100px;
  height: 3px;
  background: #206a98;
  margin: 15px auto 50px;
  border-radius: 2px;
}

.carousel-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.carousel-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  width: 100%;
}

/* ✅ Make each card a flex container for bottom alignment */
.testimonial-card {
  background: #fff;
  border: 1.5px solid #cce3ee;
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  position: relative;
  text-align: left;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* ✅ pushes footer to bottom */
  min-height: 380px; /* ensures consistent height */
}

.testimonial-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.quote-icon {
  position: absolute;
  top: 15px;
  left: 20px;
  font-size: 3rem;
  color: #e3f2f9;
  font-weight: bold;
  z-index: 0;
}

.testimonial-heading {
  font-weight: 700;
  color: #111;
  font-size: 1.1rem;
  margin-bottom: 15px;
  position: relative;
  z-index: 1;
}

.testimonial-text {
  color: #444;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 25px;
  position: relative;
  z-index: 1;
  font-style: italic;
  flex-grow: 1; /* ✅ ensures footer stays bottom */
}

/* ✅ Footer always at bottom */
.testimonial-footer {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: auto;
  padding-top: 15px;
  /* border-top: 1px solid #e8f3f7; */
}

.lab-logo {
  width: 45px;
  height: 45px;
  object-fit: contain;
}

/* ✅ Placeholder when logo is missing */
.lab-logo-placeholder {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: #e0e0e0; /* light grey fill */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  font-size: 1.1rem;
  flex-shrink: 0;
}

/* Optional hover effect for placeholder */
.lab-logo-placeholder:hover {
  background-color: #d0d0d0;
  color: #555;
}

/* ✅ Remove extra gap between name & location */
.lab-info {
  display: flex;
  flex-direction: column;
  gap: 0; /* no vertical gap */
  line-height: 1.2; /* tighten spacing */
}

.lab-info h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #000;
  margin: 0; /* remove default spacing */
}

.lab-info p {
  font-size: 0.9rem;
  color: #8b8b8b;
  margin: 0; /* remove default spacing */
}

.nav-btn {
  background: #0e829a;
  color: white;
  border: none;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
}

.nav-btn:hover {
  background: #0b6e83;
}

.prev {
  margin-right: 15px;
}

.next {
  margin-left: 15px;
}

.pagination-dots {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.pagination-dots span {
  width: 12px;
  height: 12px;
  background: #c4c4c4;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
}

.pagination-dots span.active {
  background: #206a98;
}

@media (max-width: 992px) {
  .carousel-wrapper {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .carousel-wrapper {
    grid-template-columns: 1fr;
  }
  .testimonial-card {
    text-align: center;
  }
  .testimonial-footer {
    justify-content: center;
  }
}
</style>


<!-- FontAwesome -->
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
/>
